import React from 'react';

import 'aframe';
import 'aframe-html-shader';

import HtmlElement from './HtmlElement/HtmlElement';

const AframeHtmlElement = ({
  backgroundColor,
  color,
  height,
  htmlHeight,
  htmlWidth,
  htmlId,
  forwardRef,
  position,
  planeId,
  text,
  visible,
  width,
}) => {
  return (
    <React.Fragment>
      <HtmlElement
        htmlId={htmlId}
        description={text}
        color={color}
        backgroundColor={backgroundColor}
        height={htmlHeight}
        width={htmlWidth}
      />
      <a-plane
        id={planeId || null}
        ref={forwardRef}
        visible={visible || 'true'}
        width={width || 5}
        height={height || 2}
        material={`shader: html; target: #${htmlId}; transparent: true; ratio: width; side: front;`}
        position={position}
        scale="1 1 1"
        opacity="1"
      />
    </React.Fragment>
  );
};

export default AframeHtmlElement;
